
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3d23dfac&scoped=true!less-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CardHolderRegister.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CardHolderRegister.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3d23dfac!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CardHolderRegister.vue"),
  /* scopeId */
  "data-v-3d23dfac",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/user/NonVerified/CardHolderRegister.vue
// module id = 1366
// module chunks = 18